import React from 'react';
import CourseProgressIndicator from '../CourseProgress/CourseProgressIndicator';

const CourseCard = ({ course, onSelect }) => {
  return (
    <div className="group bg-white rounded-xl border border-gray-200 hover:border-gray-300 hover:shadow-lg transition-all duration-300 h-full flex flex-col">
      {/* Header with emoji and title */}
      <div className="p-6 flex-1">
        <div className="flex items-start gap-4 mb-4">
          <div className="flex-shrink-0 w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center text-2xl group-hover:bg-gray-200 transition-colors">
            {course.emoji}
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-semibold text-gray-900 mb-1 leading-tight">
              {course.title.split(':')[0]}
            </h3>
            <p className="text-sm font-medium text-primary-600 uppercase tracking-wide">
              {course.domain}
            </p>
          </div>
        </div>
        
        <p className="text-gray-600 text-sm leading-relaxed mb-4">
          {course.description}
        </p>
        
        <div className="flex items-center justify-between">
          <div className="flex flex-wrap gap-2">
            <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-primary-50 text-primary-700">
              {course.duration}
            </span>
            <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-gray-100 text-gray-700">
              {course.difficulty}
            </span>
          </div>
          
          {/* Course Progress Indicator */}
          <div className="flex items-center gap-2">
            <CourseProgressIndicator course={course} />
          </div>
        </div>
      </div>
      
      {/* Actions */}
      <div className="px-6 pb-6">
        <button 
          onClick={() => onSelect(course)}
          className="w-full bg-primary-600 hover:bg-primary-700 text-white text-sm font-medium py-2.5 px-4 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        >
          View Course
        </button>
      </div>
    </div>
  );
};

export default CourseCard;